import { fetchFile, downloadFile } from '@/utils/download-file'

export const downloadPdf = (paymentRequestId: string) => {
  const download = async () => {
    let blob
    try {
      blob = await fetchFile(`/payment_request/${paymentRequestId}/pad_agreement.pdf`)
    } catch (e) {
      // fall-through
    }
    downloadFile(blob, `PAD Agreement ${paymentRequestId}.pdf`)
  }
  download()
}

export const getAllPdf = (paymentRequestIds: string[]) => () => {
  const files = paymentRequestIds.map(paymentRequestId =>
    fetchFile(`/payment_request/${paymentRequestId}/pad_agreement.pdf`)
  )
  Promise.allSettled(files)
    .then(results => {
      results.forEach((result, idx) => {
        if (result.status === 'fulfilled') {
          downloadFile(result.value, `PAD Agreement ${paymentRequestIds[idx]}.pdf`)
        }
      })
    })
    .catch(err => {
      // fall-through
    })
}
